import React from 'react'
import PropTypes from 'prop-types'

import {
  Container,
  Content,
  StyledSubtitle,
  StyledAmountText,
  ImageContainer,
  ClaimedTextContainer,
} from './styles'

import { Timer } from '../../atoms/timer'
import { FormatAmount } from '../../atoms/formatAmount'
import { Image } from '../../atoms/image'
import { Text } from '../../atoms/text'
import { useTranslation } from '../../../context/translationProvider'
import { getFormattedDateUTCMinus3 } from '../../../utils/datetime'

import BonusIcon from '../../../images/cashback/icon_bonus.svg'
import CashbackIcon from '../../../images/cashback.svg'
import { If } from '../../atoms/if'

export const CashbackCard = ({
  type,
  value,
  endDate,
  claimDate,
  currency,
  currencySymbol,
  expiryReminder,
  cashbackType,
}) => {
  const { translate } = useTranslation()

  const isBonus = cashbackType === 'BONUS'
  const icon = isBonus ? BonusIcon : CashbackIcon
  const label = isBonus
    ? translate('game.cashback.card.paragraph_2')
    : translate('game.cashback.card.sub-heading')

  const formattedAmount = (
    <StyledAmountText cashbackType={cashbackType}>
      <FormatAmount
        amount={value}
        shortCode={currency}
        minimumFractionDigits={2}
        maximumFractionDigits={2}
        currencySymbol={currencySymbol}
      />
    </StyledAmountText>
  )

  const image = (
    <ImageContainer $type={type}>
      <Image url={icon} />
    </ImageContainer>
  )

  return (
    <Container>
      <Content>
        <StyledSubtitle>{label}</StyledSubtitle>

        {formattedAmount}

        <If
          condition={type === 'large'}
          render={() => (
            <Timer
              endDate={new Date(endDate)}
              expiryReminder={expiryReminder}
            />
          )}
          renderElse={() => (
            <ClaimedTextContainer>
              <Text small>
                {translate('game.cashback.card.claimed-date')}{' '}
                {getFormattedDateUTCMinus3(claimDate, 'DD/MM/YYYY')}
              </Text>
            </ClaimedTextContainer>
          )}
        />
      </Content>

      {image}
    </Container>
  )
}

CashbackCard.defaultProps = {
  type: '',
  value: '',
  endDate: null,
  claimDate: '',
  currency: 'BRL',
  cashbackType: 'CASHBACK',
}

CashbackCard.propTypes = {
  type: PropTypes.string,
  value: PropTypes.string,
  endDate: PropTypes.string,
  currency: PropTypes.string,
  claimDate: PropTypes.string,
  expiryReminder: PropTypes.number,
  currencySymbol: PropTypes.string,
  cashbackType: PropTypes.oneOf(['CASHBACK', 'BONUS']),
}
